import * as React from 'react';
import { SVGProps } from 'react';

const SvgArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 5h-4l5.5 5.5H6l-2 3h11.5L10 19h4l7-7-7-7z" />
  </svg>
);

export default SvgArrow;
